import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "wedding_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authCfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const fileUrl = (path) => `${API}/files/${path}`;

// Public
export const getContent = async (draft = false) => (await axios.get(`${API}/content${draft ? "?draft=1" : ""}`)).data;
export const createRsvp = async (payload) => (await axios.post(`${API}/rsvp`, payload)).data;
export const lookupRsvp = async (whatsapp) => (await axios.get(`${API}/rsvp/lookup`, { params: { whatsapp } })).data;
export const getGuestbook = async () => (await axios.get(`${API}/guestbook`)).data;
export const createGuestbookEntry = async (payload) => (await axios.post(`${API}/guestbook`, payload)).data;
export const getSuggestions = async () => (await axios.get(`${API}/suggestions`)).data;
export const createSuggestion = async (payload) => (await axios.post(`${API}/suggestions`, payload)).data;

// Auth
export const login = async (email, password) => (await axios.post(`${API}/auth/login`, { email, password })).data;
export const getMe = async () => (await axios.get(`${API}/auth/me`, authCfg())).data;
export const changePassword = async (current_password, new_password) =>
  (await axios.post(`${API}/auth/change-password`, { current_password, new_password }, authCfg())).data;

// Admin
export const updateContent = async (content) => (await axios.put(`${API}/content`, content, authCfg())).data;
export const publishContent = async () => (await axios.post(`${API}/content/publish`, {}, authCfg())).data;
export const discardDraft = async () => (await axios.post(`${API}/content/discard`, {}, authCfg())).data;
export const contentStatus = async () => (await axios.get(`${API}/content/status`, authCfg())).data;
export const listGuestbook = async () => (await axios.get(`${API}/admin/guestbook`, authCfg())).data;
export const approveGuestbook = async (id, approved) => (await axios.patch(`${API}/guestbook/${id}`, { approved }, authCfg())).data;
export const deleteGuestbookEntry = async (id) => (await axios.delete(`${API}/guestbook/${id}`, authCfg())).data;
export const listSuggestions = async () => (await axios.get(`${API}/admin/suggestions`, authCfg())).data;
export const approveSuggestion = async (id, approved) => (await axios.patch(`${API}/suggestions/${id}`, { approved }, authCfg())).data;
export const deleteSuggestion = async (id) => (await axios.delete(`${API}/suggestions/${id}`, authCfg())).data;
export const listRsvps = async () => (await axios.get(`${API}/rsvps`, authCfg())).data;
export const rsvpStats = async () => (await axios.get(`${API}/rsvps/stats`, authCfg())).data;
export const rsvpPlanning = async () => (await axios.get(`${API}/rsvps/planning`, authCfg())).data;
export const deleteRsvp = async (id) => (await axios.delete(`${API}/rsvps/${id}`, authCfg())).data;
export const updateRsvp = async (id, data) => (await axios.patch(`${API}/rsvps/${id}`, data, authCfg())).data;

export const downloadCsv = async () => {
  const res = await axios.get(`${API}/rsvps/export`, { ...authCfg(), responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "rsvps.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/upload`, fd, {
    headers: { ...authCfg().headers, "Content-Type": "multipart/form-data" },
  });
  // Store a host-agnostic relative path; the frontend resolves it to whatever
  // backend is serving the site (preview / deploy / custom domain) at render time.
  return data.path;
};
